
export const sbTheme = {

    colour: {
        primary: "#80C341",
        secondary: "#01A2E0",
        tertiary: "#FFD433",

        primaryMuted: "#E7F3D5",
        secondaryMuted: "#CCEAF6",
        tertiaryMuted: "#FFF29D"
    }

}
